import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=3b871774&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Aside.vue?vue&type=style&index=1&id=3b871774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b871774",
  null
  
)

export default component.exports